export default __webpack_public_path__ + "static/logo-38f7be6096985aaf2615a4a442065a63.svg";